import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/select";
import { StaffAvatar } from "@/components/StaffAvatar";

type Props = {
  value: string | null;
  /** `name` — tên của người vừa chọn, cho chỗ cần hiện tên ngay mà không tra lại. */
  onChange: (id: string | null, name?: string) => void;
  placeholder?: string;
};

export function StaffPicker({ value, onChange, placeholder = "Chọn nhân viên" }: Props) {
  const { data } = useQuery({
    queryKey: ["staff", "list"],
    queryFn: () => api.GET("/staff", {}).then((r) => r.data ?? []),
    staleTime: 5 * 60_000,
  });

  return (
    <Select
      value={value ?? ""}
      onValueChange={(v) => onChange(v || null, (data ?? []).find((s) => s.id === v)?.name)}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {(data ?? []).map((s) => (
          // textValue keeps type-ahead on the name: with an avatar inside,
          // Radix would otherwise search node.textContent, which now leads
          // with the fallback initials.
          <SelectItem key={s.id} value={s.id} textValue={s.name}>
            <span className="inline-flex items-center gap-1.5">
              <StaffAvatar staffId={s.id} name={s.name} sizePx={24} />
              {s.name}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
